import { useEffect } from 'react';
import { useAuth } from '../shared/auth/AuthContext';

const RECENT_LOGOUT_WINDOW_MS = 5 * 60 * 1000; // 5 minutes

function wasRecentlyLoggedOut() {
  const ts = localStorage.getItem('app.logout');
  return ts !== null && Date.now() - Number(ts) < RECENT_LOGOUT_WINDOW_MS;
}

export default function AuthGuard({ children }) {
  const { isAuthEnabled, isLoading, isAuthenticated } = useAuth();

  useEffect(() => {
    if (isAuthEnabled && !isLoading && !isAuthenticated) {
      if (wasRecentlyLoggedOut()) {
        // Require explicit user interaction before re-auth to avoid browser retry loops.
        window.location.href = '/signed-out';
      } else {
        const returnUrl = encodeURIComponent(window.location.pathname + window.location.search);
        window.location.href = `/api/auth/login?returnUrl=${returnUrl}`;
      }
    }
  }, [isAuthEnabled, isLoading, isAuthenticated]);

  if (isLoading || !isAuthenticated) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
        <span>Loading...</span>
      </div>
    );
  }

  return children;
}
